import React, { useContext } from "react";
import { CartContext } from "./CartContext";
import productData, { formatPrice, siteConfig } from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { FiArrowLeft, FiMinus, FiPlus, FiShoppingBag, FiTrash2, FiTruck } from "react-icons/fi";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);
  const getProduct = (id) => productData.find((product) => product.id === id);
  const subtotal = cartItems.reduce((total, item) => {
    const product = getProduct(item.id);
    return product ? total + product.price * item.quantity : total;
  }, 0);
  const shipping = subtotal === 0 ? 0 : siteConfig.shipping.standard;
  const total = subtotal + shipping;

  if (cartItems.length === 0) {
    return (
      <main className="cart-page cart-page--empty">
        <FiShoppingBag />
        <h1>Your cart is empty</h1>
        <p>There’s plenty of room for a new pen, a fresh sketchbook or a little more colour.</p>
        <Link to="/shop">Start shopping</Link>
      </main>
    );
  }

  return (
    <main className="cart-page">
      <nav className="cart-page__breadcrumbs" aria-label="Breadcrumb"><Link to="/">Home</Link><span>→</span><span>Cart</span></nav>
      <div className="cart-page__heading">
        <div><p>Your selection</p><h1>Shopping cart</h1></div>
        <span>{cartItems.reduce((sum, item) => sum + item.quantity, 0)} items</span>
      </div>

      <div className="cart-page__layout">
        <section className="cart-page__items" aria-label="Cart items">
          {cartItems.map((item) => {
            const product = getProduct(item.id);
            if (!product) return null;
            return (
              <article key={`${item.id}-${item.size}-${item.color}`} className="cart-page__item">
                <Link to={`/shopDetails/${product.id}`}><img src={product.image} alt={product.name} /></Link>
                <div className="cart-page__item-info">
                  <span>{product.brand}</span>
                  <Link to={`/shopDetails/${product.id}`}>{product.name}</Link>
                  <small>{item.size} · {item.color}</small>
                  <button type="button" onClick={() => removeFromCart(item.id, item.size, item.color)}><FiTrash2 /> Remove</button>
                </div>
                <div className="cart-page__item-actions">
                  <div>
                    <button type="button" aria-label={`Decrease ${product.name} quantity`} onClick={() => updateQuantity(item.id, item.size, item.color, item.quantity - 1)}><FiMinus /></button>
                    <span aria-live="polite">{item.quantity}</span>
                    <button type="button" aria-label={`Increase ${product.name} quantity`} onClick={() => updateQuantity(item.id, item.size, item.color, item.quantity + 1)}><FiPlus /></button>
                  </div>
                  <strong>{formatPrice(product.price * item.quantity)}</strong>
                </div>
              </article>
            );
          })}
          <Link className="cart-page__continue" to="/shop"><FiArrowLeft /> Continue shopping</Link>
        </section>

        <aside className="cart-page__summary">
          <h2>Order summary</h2>
          <dl>
            <div><dt>Subtotal</dt><dd>{formatPrice(subtotal)}</dd></div>
            <div><dt>Tracked shipping</dt><dd>{formatPrice(shipping)}</dd></div>
          </dl>
          <div className="cart-page__shipping-progress"><p><FiTruck /> Fixed tracked shipping is {formatPrice(siteConfig.shipping.standard)} per order.</p></div>
          <div className="cart-page__total"><span>Total <small>USD</small></span><strong>{formatPrice(total)}</strong></div>
          <button type="button" onClick={() => { navigate("/checkout"); window.scrollTo({ top: 0, behavior: "smooth" }); }}>Go to checkout</button>
          <p className="cart-page__secure">Secure checkout · Payment details are handled by the payment provider</p>
        </aside>
      </div>
    </main>
  );
};

export default CartPage;
